import { render, staticRenderFns } from "./safetyFormsSummaryReportTable.vue?vue&type=template&id=3bc49c95&scoped=true"
import script from "./safetyFormsSummaryReportTable.vue?vue&type=script&lang=js"
export * from "./safetyFormsSummaryReportTable.vue?vue&type=script&lang=js"
import style0 from "./safetyFormsSummaryReportTable.vue?vue&type=style&index=0&id=3bc49c95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc49c95",
  null
  
)

export default component.exports